import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';

export default function ITServices() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ServicesGrid />
      <Footer />
    </div>
  );
}